"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = require("@emotion/react");

var _util = require("../../util");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  from {\n    transform: scale(1);\n  }\n  to {\n    transform: scale(2);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ripple = (0, _react.keyframes)(_templateObject());

var circle = function circle(_ref) {
  var color = _ref.color,
      rippleColor = _ref.rippleColor;
  return /*#__PURE__*/(0, _react.css)("position:relative;display:inline-block;width:", (0, _util.rem)(12), ";height:", (0, _util.rem)(12), ";border-radius:50%;&:before{content:'';background-color:", rippleColor, ";position:absolute;width:100%;height:100%;border-radius:inherit;animation:", ripple, " 1.6s infinite;opacity:0.5;}&:after{content:'';background-color:", color, ";position:absolute;width:100%;height:100%;border-radius:inherit;}" + (process.env.NODE_ENV === "production" ? "" : ";label:circle;"));
};

var styles = {
  circle: circle
};
exports.styles = styles;
//# sourceMappingURL=ProgressCircle.styles.js.map